import coreKeys from 'treeline-react-core-components/localizationKeys'; // These keys are referenced by components in the lib

const localizationKeys = [
	...coreKeys,
	'a_link_to_reset_your_password',
	'access_currently_unauthorized',
	'account_information_saved',
	'account_name',
	'account_search',
	'account_type',
	'account',
	'active',
	'add_another_quantity',
	'add_another_quantity',
	'add_event_to_communities_subheader',
	'add_new',
	'add_this_title_to_an_available_list',
	'add_title_to_list_instructions',
	'add_titles_to_event_popover_content',
	'add_titles_to_list_instructions',
	'add_to_collaborative_list',
	'add_to_shelf_collection',
	'add_your_event_to_relevant_communities',
	'add',
	'added_by',
	'additional_information',
	'address',
	'affiliation',
	'age_range_filter_help',
	'age_range_filters',
	'age_range',
	'alert_type',
	'all',
	'all_genres',
	'all_titles',
	'allow_add_by_group_help',
	'allow_add_by_group',
	'already_have_an_edelweiss_acount',
	'archive',
	'archive',
	'are_you_sure_you_want_to_delete_this_circle',
	'are_you_sure_you_want_to_delete_this_community',
	'are_you_sure_you_want_to_save',
	'are_you_sure',
	'associated_titles',
	'author',
	'available_for_download',
	'available_for_request',
	'back_to_home',
	'back_to',
	'back',
	'backlist',
	'beta',
	'blog_personal',
	'booksellers',
	'browse_review_copies_by_genre',
	'buzz_across_communities',
	'buzz_for_x_community',
	'buzz',
	'by_clicking_sign_up',
	'cancel',
	'catalog_search',
	'catalogs',
	'category_filter_help',
	'category',
	'change_email_address',
	'change_password',
	'change',
	'changes_have_been_saved',
	'changes_saved',
	'circle_of_x',
	'circle_removed',
	'circle_saved',
	'circles_description',
	'circles',
	'city',
	'clear_title_selections',
	'click_either_image_to_edit_it',
	'click_here_to_search_for_titles',
	'click_to_attend',
	'click_to_edit_image',
	'click_to_learn_more_about_banner_content',
	'click_to_upload_main_event_image',
	'collaborative_list_management',
	'collaborative_list',
	'collaborative_lists',
	'collaborative_title_lists',
	'coming_soon',
	'comment',
	'comments',
	'common_across_requests',
	'communication_settings_saved',
	'communication_settings',
	'communities_your_event_will_be_added_to',
	'communities',
	'community_activity',
	'community_buzz_description',
	'community_buzz',
	'community_conversations_description',
	'community_does_not_exist_or_must_be_invited',
	'community_events_lane_description',
	'community_guidelines',
	'community_hub',
	'community_organized_by_x',
	'community_removed',
	'community_saved',
	'community_search',
	'community_updated',
	'community',
	'compressed_zip_file_with_all_chapter_mp3_files',
	'confirm_delete_filter',
	'continue',
	'contributors',
	'conversations',
	'country',
	'course',
	'create_affiliation',
	'create_collaborative_list',
	'create_event',
	'create_new_circle',
	'create_new_comment',
	'create_new_community',
	'create_saved_filter',
	'create',
	'cropped_image_preview',
	'cropper_is_set_to_max_dimensions',
	'current_email_subscriptions_uncheck_to_unsubscribe',
	'current_password',
	'currently_no_scheduled_events_for_communities_you_are_a_member_of',
	'currently_no_scheduled_events_for_this_community',
	'currently_no_scheduled_events_for_your_communities',
	'currently_reading_short',
	'currently_unavailable_via_the_edelweiss_web_reader',
	'date_is_required',
	'date',
	'default_sort',
	'delete',
	'delete_event_in_community_confirm_prompt',
	'delete_community',
	'delete_photo',
	'department',
	'desc_summary',
	'description_is_required',
	'description_of_role',
	'description',
	'dewey_filter_help',
	'dewey',
	'did_not_meet_image_requirements_message',
	'digital',
	'disable_ability_to_x',
	'dont_have_an_edelweiss_account',
	'down',
	'download_and_read',
	'download_drc',
	'download_method',
	'download_option',
	'download_ready',
	'download_the_drc',
	'download_title_csv',
	'download',
	'downvote',
	'downvotes',
	'draft',
	'drc_adobe_digital_editions',
	'drc_audio_description',
	'drc_audio_message',
	'drc_availability_filter_help',
	'drc_availability',
	'drc_downloaded',
	'drc_downloading_message',
	'drc_external_url_message',
	'drc_kindle_description',
	'drc_kindle_message',
	'drc_kindle_profile',
	'drc_method',
	'drc_open_drm_message',
	'drc_select_format',
	'drc_set_preferred_format',
	'drc_standard_description',
	'drc_standard_message_parttwo',
	'drc_standard_message',
	'drc_will_expire_in',
	'drc_will_expire_on',
	'edelweiss_community_newsletters',
	'edelweiss_plus_emails',
	'edit_account_info',
	'edit_circle',
	'edit_collaborative_list',
	'edit_comment',
	'edit_community',
	'edit_filter',
	'edit_personal_info',
	'edit',
	'edition_filter_help',
	'edition',
	'eligible_community_nonmember_alert',
	'email_address',
	'enable_quantity_inputs_help',
	'enable_quantity_inputs_help',
	'enable_quantity_inputs',
	'enable_quantity_inputs',
	'end_time_is_required',
	'end_time',
	'enter_current_password',
	'enter_your_id',
	'error_boundary_default_fallback_message',
	'error_occurred_please_try_again_later',
	'error_retrieving_communication_settings',
	'error_saving_account_information',
	'error_saving_links',
	'error_saving_personal_information',
	'error_saving_role_description',
	'error_saving_role_summary',
	'error',
	'evalDesc_1',
	'evalDesc_2',
	'evalDesc_3',
	'evalDesc_4',
	'evalType_0',
	'evalType_1',
	'evalType_2',
	'evalType_3',
	'evalType_4',
	'evaluation_purpose',
	'event_image',
	'event_images',
	'event_link',
	'event_organization_name',
	'event_organizer_image',
	'event_title_is_required',
	'event_title',
	'event_url_is_required',
	'event_url_to_learn_more_and_or_register',
	'event_url',
	'events',
	'exclude_from_filter',
	'exp_enrollment',
	'expired',
	'export_list',
	'featured_titles',
	'feedback',
	'filter_excluded',
	'filter_included',
	'filter',
	'find_a_community',
	'first_name_and_last_name_are_required',
	'first_name',
	'forgot_password_email_sent',
	'forgot_password',
	'format_filter_help',
	'format_filters',
	'format',
	'frontlist',
	'full_name',
	'gain_more_recognition_by_publishers_react',
	'general_readers_or_reviewers',
	'genre_category_filters',
	'genre_communities_authorization_instructions',
	'genre_communities',
	'go_back_to',
	'go_to_edelweiss',
	'here',
	'home_buzz_description',
	'home_catalog_folders_description',
	'home_collaborative_lists_description',
	'home_communities_description',
	'home_conversations_description',
	'home_events_lane_description',
	'home_my_reader_drcs_description',
	'home_new_review_copies_description',
	'home_your_review_copies_description',
	'home_your_shelves_description',
	'home',
	'if_you_close_the_drawer_you_will_lose_unsaved_work',
	'if_you_want_account_to_be_searchable_click_checkbox',
	'image_dimension_requirements',
	'images_with_quantity_in_parenthesis',
	'immediate_email',
	'immediate_text',
	'imprint_filter_help',
	'imprint_filters',
	'imprint',
	'in_person',
	'include_in_filter',
	'individual_chapters',
	'ineligible_community_nonmember_alert',
	'interactive',
	'invalid_date',
	'invalid_login_please_try_again',
	'invited',
	'is_of_interest_to',
	'isbn',
	'issue_loading_title_details',
	'issue_with_request_message',
	'join_community_with_validation_success_message',
	'join_community',
	'join',
	'joined',
	'key_selling_points',
	'kindle_additional_info_required',
	'kindle_email_address',
	'kindle_email_disclaimer',
	'kindle_in_order_to_send_point_four',
	'kindle_in_order_to_send_point_one',
	'kindle_in_order_to_send_point_three',
	'kindle_in_order_to_send_point_two',
	'kindle_in_order_to_send',
	'kindle_information',
	'kindle_method_send_to_email',
	'kindle_method_send_to_kindle',
	'last_activity',
	'last_activity_x',
	'last_name',
	'last_viewed_on_x',
	'learn_more',
	'less',
	'lexile_filter_help',
	'lexile',
	'librarians',
	'link_social_media_accounts',
	'link_to_virtual_event_is_required',
	'link_to_virtual_event',
	'link_your_goodreads_account',
	'links_saved',
	'list_archived',
	'list_moved_to_active',
	'list_pinned',
	'lists_this_title_is_on',
	'live_from_your_device',
	'loading_buzz',
	'loading_review_copies',
	'loading_x_saved_filter',
	'location',
	'log_in_with_your_edelweiss_account',
	'log_in',
	'make_account_searchable',
	'manage_list_notifications',
	'manage_notifications',
	'mark_unread',
	'marketing_plans',
	'max_8000_list',
	'mechanism',
	'messages',
	'more',
	'most_active_reviewers_description',
	'most_active_reviewers',
	'move_to_active',
	'move_to_active',
	'must_be_authorized_to_post_to_genre_communities_form_prompt',
	'must_be_invited_to_community_message',
	'must_select_one',
	'my_edelweiss_reader_review_copies',
	'my_events',
	'name',
	'net_votes',
	'new_password_confirm',
	'new_password',
	'new_review_copies',
	'new_saved_filter_help_examples',
	'new_saved_filter_help',
	'next',
	'no_active_collaborative_lists',
	'no_activity',
	'no_activity',
	'no_communities_found',
	'no_filters_selected_choose_from_below',
	'no_image_available',
	'no_image_available',
	'no_matches_found_no_punctuation',
	'no_matches_found',
	'no_overview',
	'no_role_specified',
	'no_titles_have_been_added_to_this_list_yet',
	'no_titles_match_those_search_terms',
	'no_titles',
	'no',
	'none',
	'not_included_on_any_lists',
	'not_member_of_any_communities',
	'not_set',
	'not_specified',
	'noticeType_1',
	'noticeType_10',
	'noticeType_11',
	'noticeType_12',
	'noticeType_13',
	'noticeType_2',
	'noticeType_3',
	'noticeType_4',
	'noticeType_5',
	'noticeType_6',
	'noticeType_7',
	'noticeType_8',
	'noticeType_9',
	'number_of_links',
	'official_genre_community_managed_by_x',
	'ok',
	'one_reply',
	'one_thought',
	'only_admins',
	'optional_comment_30',
	'optional_comment_30',
	'options',
	'organization_event_image_override_warning',
	'organization_logo',
	'other_user_created',
	'others_can_add_to_help',
	'others_can_add_to_help',
	'others_can_add_to',
	'others_can_add_to',
	'password_must_be_at_least',
	'password',
	'passwords_do_not_match',
	'past_event',
	'past',
	'personal_information_saved',
	'personal_information',
	'phone_number',
	'phone',
	'pin',
	'pin',
	'pinned',
	'please_confirm_your_password',
	'please_enter_a_name_for_this_list',
	'please_enter_your_email_and_click_submit',
	'please_enter_your_first_name',
	'please_enter_your_last_name',
	'please_enter_your_validation_id',
	'please_input_your_current_password',
	'please_log_in_to_your_account',
	'please_provide_a_password',
	'please_provide_a_valid_email_address',
	'please_provide_shipping_for_request',
	'please_provide_your_email_address',
	'please_select_a_country',
	'please_select',
	'please_try_again',
	'please_verify_that_you_are_not_a_robot',
	'pos_categories',
	'postal',
	'presented_by',
	'price',
	'print',
	'profile_editor',
	'profile_picture',
	'profile_strength_description',
	'profile_strength',
	'profile_summary_saved',
	'profile_summary',
	'pub_date',
	'pubdate_filter_help',
	'pubdate_filters',
	'pubdate',
	'published',
	'publisher_filter_help',
	'publisher',
	'qty',
	'qty',
	'qualifier',
	'quantities',
	'quantity',
	'quotes',
	'read_in_the_edelweiss_web_reader',
	'read_online',
	'registration_keep_me_updated',
	'remember_me',
	'remove',
	'request_for',
	'request_sent_for',
	'requested',
	'requiring_valid_id',
	'reset_cropper',
	'reset_password',
	'retrieve_prepared_file',
	'return_home',
	'return_to_request',
	'review_copies_for_all_genres',
	'review_copies_relevant_to_x_community',
	'review_copy_available',
	'review_copy_relevant_to_x_community',
	'review_copy_request_form',
	'review_of_x',
	'role_desc_note',
	'role_description_saved',
	'role_summary_saved',
	'role_summary',
	'save_changes',
	'save_event',
	'save_links',
	'save_role_description',
	'save',
	'saved_filter',
	'saved_filters',
	'search_all_catalogs',
	'search_for_communities',
	'search_for_titles',
	'search',
	'see_more_event_details_here',
	'see_the_event_recording_here',
	'select_best_option_for_request',
	'select_one',
	'send_to',
	'sending',
	'sequence',
	'share_or_export',
	'ship_to_address',
	'show_larger_jacket_cover',
	'show_less',
	'show_more',
	'show_smaller_jacket_cover',
	'sign_up_for_an_edelweiss_account',
	'sign_up',
	'social_media_links_below_will_appear_in_profile',
	'sort_by',
	'sorted_by',
	'list_sort_by_help',
	'standard',
	'start_conversation_in_another_community',
	'start_time_is_required',
	'start_time',
	'state',
	'status_help',
	'status_loading',
	'status',
	'step_one_event_details',
	'step_three_add_communities',
	'step_two_upload_images',
	'submit',
	'subrights_filter_help',
	'subrights',
	'success',
	'tb_author_bio',
	'terms_of_service',
	'the_email_address_you_have_provided_is_already_registered_with_edelweiss',
	'the_name_of_the_organization_presenting_the_event',
	'the_title_has_been_added',
	'the_titles_have_been_added',
	'there_are_no_past_events_for_communities_you_are_a_member_of',
	'there_are_no_past_events_for_this_community',
	'there_was_an_error_with_your_request',
	'time_zone',
	'time_zone_community_event_tooltip',
	'title_information',
	'title_review',
	'title_search',
	'title',
	'titles_added_removed',
	'titles_already_on_a_list_will_not_be_added_again',
	'titles_you_edited',
	'titles',
	'too_short',
	'tooltip_reviewed',
	'topic_x',
	'type_of_activity',
	'unable_to_validate_community_code',
	'unarchive',
	'unauthorized_retrieving_communication_settings',
	'unknown_title',
	'unpin',
	'unsubscribe_from_all_emails_disclaimer_in_communication_settings',
	'unsubscribe_from_all_emails',
	'unsubscribe_from_friend_emails',
	'unsubscribe_from_friend_emails_disclaimer_in_communication_settings',
	'until_your_event_has_been_added_to_a_community_it_will_not_be_seen_by_others',
	'up',
	'upcoming_event',
	'upcoming_events',
	'upcoming',
	'upcoming',
	'update_community_photo',
	'update_photo',
	'update',
	'updated_x_date',
	'upload_an_event_organization_image_for_your_whole_organization',
	'upload_an_organization_image_specific_to_this_event',
	'upload_organization_image',
	'upload_photo',
	'upvote',
	'upvotes',
	'use_organizations_event_image_switch_prompt',
	'validation_id',
	'venue_address_is_required',
	'venue_address',
	'venue_name_is_required',
	'venue_name',
	'view_edit_your_profile',
	'view_mode',
	'virtual_uppercase',
	'virtual',
	'visit_event_page_in_new_tab_question',
	'votes',
	'want_to_have_your_event_listed_here_prompt',
	'watch_recording',
	'where_x_y',
	'where_x',
	'where',
	'why_are_you_requesting_this_title',
	'word_for_example',
	'word_more',
	'word_or',
	'word_you',
	'word_you',
	'would_you_like_to_update_the_event_organization_image',
	'x_community_conversation_title',
	'x_community_hub',
	'x_community',
	'x_is_required',
	'x_member_of_the_y_account',
	'x_member',
	'x_members_of_the_y_account',
	'x_members',
	'x_notification',
	'x_other_conversation',
	'x_other_conversations',
	'x_profile',
	'x_replies',
	'x_thoughts',
	'yes',
	'you_do_not_currently_manage_any_communities',
	'you_have_no_events_for_this_filter_in_this_community',
	'you_have_no_events_for_this_filter',
	'you_have_no_scheduled_or_past_events_for_this_community',
	'you_have_no_scheduled_or_past_events',
	'you_have_not_added_your_event_to_communities',
	'you_must_be_a_member_of_the_x_community',
	'you_must_be_logged_in_to_edelweiss_plus_to_view_this_page',
	'you_must_have_an_edelweiss_account',
	'you',
	'your_books_help',
	'your_books',
	'your_communities',
	'your_event_has_been_deleted',
	'your_event_has_been_saved',
	'your_image_has_been_deleted',
	'your_image_has_been_saved',
	'your_password_has_been_changed',
	'your_review_copies',
	'your_saved_profile',
	'your_shared_reviews_description',
	'your_shared_reviews',
	'your_shelves_and_collections',
	'your_vote_has_been_recorded',
	'your_vote_has_been_removed',
]; // Add any other localization keys you need for your app here.

export default localizationKeys;
